module.exports = __webpack_public_path__ + "img/745-6480da.png";